import { render, staticRenderFns } from "./OverdueServicesList.vue?vue&type=template&id=5c1027e2&scoped=true"
import script from "./OverdueServicesList.vue?vue&type=script&lang=js"
export * from "./OverdueServicesList.vue?vue&type=script&lang=js"
import style0 from "./OverdueServicesList.vue?vue&type=style&index=0&id=5c1027e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1027e2",
  null
  
)

export default component.exports